/** ---------------------------------------------------------------------------------------
 * --  LICENSE AGREEMENT -- *
 This software is licensed under the following terms:

 * -- GRANT OF LICENSE | RESTRICTIONS -- *
 Subject to the terms and conditions of this license, the copyright holders
 hereby grant you a non-exclusive, non-transferable, revocable license to use,
 copy, modify, and distribute the software.
 You are expressly prohibited from selling or commercially exploiting the software.
 Unauthorized use, reproduction, or distribution of the software, or any part
 thereof, is strictly prohibited.

 * -- AUTHORIZED USERS | INTELLECTUAL PROPERTY -- *
 This license is granted only to the individual or entity to whom the software is
 directly distributed by the copyright holders. Any use by other individuals or
 entities is unauthorized and in violation of this license. The software is
 protected by copyright and other intellectual property laws.
 The copyright holders retain all rights, title, and interest in the software.

 * -- GOVERNING LAW -- *
 This license is governed by and construed in accordance with the laws of Romania.
 Any legal action or proceeding related to this license shall be brought exclusively
 in the courts of Romania.

 [Weddify x Diaphan Stationery] © [2024] All rights reserved.
 -------------------------------------------------------------------------------------- **/
'use client'
import React from 'react';
import Link from "next/link";

const AppConfidentialityPolicy = () => {

    const scrollToTop = () => {
        window.scrollTo({top: 0, behavior: 'smooth'});
    }

    return (
        <div className="app-policy pt-32 md:pt-40 pb-10 pl-5 pr-5 sm:pl-10 sm:pr-10 lg:pl-20 lg:pr-20 bg-white/10">
            <h1 className="text-2xl font-bold">Politică Confidențialitate</h1>
            <p className="app-space-dummy"></p>
            <p className="font-bold text-xl mb-2"><strong>1. Informații Generale</strong></p>
            <p>Confidențialitatea Datelor dumneavoastră cu Caracter Personal reprezintă una dintre preocupările
                principale ale ENFASI LIVING CONCEPT S.R.L., cu sediul in Bucureşti, Sectorul 4, Strada Nifon
                Mitropolitul, nr. 34, inregistrata la Registrul Comertului de pe langa Tribunalul Bucuresti sub nr.
                J40/2940/2021 ce are cod fiscal RO 43763456, în calitate de operator de Date.</p>
            <p className="app-space-dummy"></p>
            <p className="font-bold text-xl mb-2"><strong>2. Definiții & Termeni</strong></p>
            <p><strong>Platforma/Site-ul WEDDIFY</strong> – este programul software ce se poate accesa prin orice
                dispozitiv care are
                acces la un browser prin link-ul <a href="https://weddify.net">weddify.net</a> si care permite accesul
                Utilizatorilor/Clienților/Cumpărătorilor la Serviciile WEDDIFY.</p>
            <p><strong>Serviciile WEDDIFY</strong> – reprezintă totalitatea funcționalităților ce oferite de către
                ENFASI LIVING CONCEPT S.R.L prin intermediul Platformei, Serviciile de Newsletter, precum și Pachete de
                Servicii.</p>
            <p><strong>Pachetele de Servicii</strong> – reprezintă un serviciu software de tip SaaS (System As A
                Service) care este pus la dispoziția Cumpărătorului sub formă de abonament și care permite construirea
                de către acesta a propriului site web
                dedicat nunții sau evenimentului său special, fără a fi nevoie de instalarea sau mentenanța acestuia de
                către Cumpărător.</p>
            <p><strong>Serviciile de Newsletter</strong> – reprezintă o forma de publicație periodică transmisă prin
                e-mail
                Clienților/Utilizatorilor/Cumpărătorilor ce aleg să se aboneze, prin intermediul căreia, aceștia din
                urmă vor fi informați cu privire la noile Servicii oferite în cadrul Platformei, actualizarea
                prețurilor, eventuale oferte, și alte asemenea.</p>
            <p><strong>Client</strong> - orice persoană fizică cu vârsta de peste 18 ani, persoana juridică sau orice
                altă entitate care utilizează Serviciile Vânzătorului și căruia îi sunt Prelucrate Date cu Caracter
                Personal.</p>
            <p><strong>Comandă</strong> - un document ce intervine ca formă de comunicare între Vânzător și Cumpărător,
                prin care
                Cumpărătorul transmite Vânzătorului, prin intermediul site-ului, intenția sa de a achiziționa Pachetul
                de Servicii.</p>
            <p><strong>Cumpărător</strong> - persoana fizică sau juridică care a achiziționat unul dintre Pachetele puse
                la dispoziție pe site-ul <a href="https://weddify.net">weddify.net</a> și căruia îi sunt Prelucrate Date
                cu Caracter Personal.</p>
            <p><strong>Vizitator/Utilizator</strong> – persoana fizică sau juridică ce accesează site-ul <a
                href="https://weddify.net">weddify.net</a>.
            </p>
            <p><strong>Consimțământul persoanei vizate</strong> - orice manifestare de voință liberă, specifică,
                informată și lipsită de
                ambiguitate a persoanei vizate prin care aceasta acceptă, printr-o, declarație sau printr-o acțiune fără
                echivoc, ca Datele cu Caracter Personal care o privesc sa fie Prelucrate, inclusiv accesarea butonului
                „de acord” după citirea termenilor si condițiilor prezente.
            </p>
            <p><strong>Date cu Caracter Personal</strong> - orice informații privind o persoană fizică identificată sau
                identificabilă
                („Persoană Vizată"); o persoană fizică identificabilă este o persoană care poate fi identificată, direct
                sau indirect, în special prin referire la un element de identificare, cum ar fi un nume, un număr de
                identificare, Date de localizare, un identificator online sau unul sau mai multe elemente specifice,
                proprii identității sale fizice, fiziologice, genetice, psihice, economice, culturale sau sociale.
            </p>
            <p><strong>Prelucrare</strong> - orice operațiune sau set de operațiuni efectuate asupra Datelor cu Caracter
                Personal sau
                asupra seturilor de Date cu Caracter Personal, cu sau fără utilizarea de mijloace automatizate, cum ar
                fi colectarea, înregistrarea, organizarea, structurarea, stocarea, adaptarea sau modificarea,
                extragerea, consultarea, utilizarea, divulgarea prin transmitere, diseminarea sau punerea la dispoziție
                în orice alt mod, alinierea sau combinarea, restricționarea, ștergerea sau distrugerea.
            </p>
            <p><strong>Materiale</strong> – reprezintă totalitatea fotografiilor, melodiilor, informațiilor, Datelor și
                alte asemenea
                încărcate și publicate de Cumpărător pe Website-ul de eveniment.
            </p>
            <p><strong>Website-ul de eveniment</strong> – reprezintă website-ul creat de Cumpărător ca urmare a
                achiziționării Serviciilor oferite pe Platformă.
            </p>

            <p className="app-space-dummy"></p>
            <p className="font-bold text-xl mb-2"><strong>3. Categoriile de Date cu Caracter Personal Prelucrate</strong></p>
            <p><strong>3.1</strong> Dacă sunteți Client al Site-ului, ENFASI LIVING CONCEPT S.R.L. va Prelucra Datele
                dumneavoastră cu
                Caracter Personal, cum ar fi nume şi prenume, telefon, adresa de e-mail, adresa de facturare, Date
                referitoare la modul în care utilizați Site-ul, de exemplu comportamentul/preferinţele dumneavoastră în
                cadrul ENFASI LIVING CONCEPT S.R.L., precum și orice alte categorii de Date pe care le furnizați în mod
                direct în contextul creării contului de Client ori Cumpărător, în contextul achiziționării unui Pachet
                de Servicii ori utilizării Serviciilor de Newsletter prin intermediul Site-ului, în vederea încheierii
                contractelor aferente Serviciilor sau în orice alt mod care rezultă din utilizarea Site-ului.</p>
            <p><strong>3.2</strong> Dacă sunteți Vizitator al Site-ului, S.C. ENFASI LIVING CONCEPT S.R.L. va Prelucra
                Datele
                dumneavoastră cu Caracter Personal pe care le furnizați în mod direct în contextul utilizării Site, cum
                ar fi Datele pe care le furnizați în cadrul secțiunii de contact / întrebări / reclamații, în măsura în
                care ne contactați în acest fel.</p>
            <p><strong>3.3</strong> În cazul în care alegeți să achiziționați un Pachet de Servicii, înainte de a
                finaliza procesul de
                achiziție al Pachetului, se vor Prelucra următoarele Date cu Caracter Personal – numele, prenumele,
                adresa de e-mail, numărul de telefon, adresa de domiciliu. În cazul în care nu
                finalizați procesul de achiziție, Datele furnizate nu vor fi stocate de ENFASI LIVING CONCEPT S.R.L.
            </p>
            <p><strong>3.4</strong> Pentru finalizarea procesului de setup, ENFASI LIVING CONCEPT S.R.L. va Prelucra
                următoarele Date cu
                Caracter Personal – adresa de e-mail și adresa URL al Website-ului de Eveniment.
            </p>
            <p>În vederea Personalizării Website-ului de Evenimente, Cumpărătorul va publica materiale ce conțin
                Date cu Caracter Personal, astfel pentru funcționarea optimă a Website-ului de Eveniment, ENFASI LIVING
                CONCEPT S.R.L. va Prelucra Date cu Caracter Personal din imaginile foto publicate, Datele de
                identificare ale participanților, data și locul evenimentului, precum și din alte materiale ori alte
                informații publicate pe Website-ul de Eveniment.
            </p>
            <p className="app-space-dummy"></p>
            <p className="font-bold text-xl mb-2"><strong>4. Scopurile și temeiurile Prelucrării</strong></p>
            <p><strong>4.1</strong> Dacă sunteți Cumpărător ori Client al Site-ului, ENFASI LIVING CONCEPT S.R.L.
                Prelucrează Datele dumneavoastră cu Caracter Personal astfel:
            </p>
            <ul className="nested-list">
                <li>pentru desfășurarea relației contractuale dintre dumneavoastră şi ENFASI LIVING CONCEPT S.R.L.,
                    respectiv pentru abonarea la Serviciile de Newsletter.
                </li>
            </ul>
            <p>Prelucrarea Datelor dumneavoastră în acest scop are la bază contractul încheiat între dumneavoastră și
                ENFASI LIVING CONCEPT S.R.L., definit în cuprinsul
                <Link onClick={scrollToTop} href={'/info/termeni-si-conditii'}> Termenelor și Condițiilor</Link>.
                Furnizarea Datelor dumneavoastră cu Caracter Personal este necesară pentru abonarea dvs. la Serviciile
                de Newsletter. Refuzul furnizării Datelor poate avea drept consecință imposibilitatea derulării
                raporturilor contractuale dintre dumneavoastră și ENFASI LIVING CONCEPTT S.R.L.</p>
            <ul className="nested-list">
                <li>pentru desfășurarea relației contractuale dintre dumneavoastră şi ENFASI LIVING CONCEPT S.R.L.,
                    respectiv pentru preluarea, validarea şi facturarea comezii plasate pe Site.
                </li>
            </ul>
            <p>Prelucrarea Datelor dumneavoastră în acest scop are la bază contractul încheiat între dumneavoastră și
                ENFASI LIVING CONCEPT S.R.L., definit în cuprinsul
                <Link onClick={scrollToTop} href={'/info/termeni-si-conditii'}> Termenelor și Condițiilor</Link>.
                Furnizarea Datelor dumneavoastră cu Caracter Personal este necesară pentru furnizarea Pachetului de
                Servicii. Refuzul furnizării Datelor poate avea drept consecință imposibilitatea derulării raporturilor
                contractuale dintre dumneavoastră și ENFASI LIVING CONCEPT S.R.L.</p>
            <ul className="nested-list">
                <li>pentru desfășurarea relației contractuale dintre dumneavoastră şi ENFASI LIVING CONCEPT S.R.L.,
                    respectiv pentru încheierea contractului, derularea Pachetului de Servicii.
                </li>
            </ul>
            <p>Prelucrarea Datelor dumneavoastră în acest scop are la bază contractul încheiat între dumneavoastră și
                ENFASI LIVING CONCEPT S.R.L. Furnizarea Datelor dumneavoastră cu Caracter Personal este necesară pentru
                executarea acestui contract. Refuzul furnizării Datelor poate avea drept consecință imposibilitatea
                derulării raporturilor contractuale dintre dumneavoastră și ENFASI LIVING CONCEPT S.R.L.</p>
            <ul className="nested-list">
                <li>pentru îndeplinirea obligațiilor legale care incumbă ENFASI LIVING CONCEPT S.R.L. în contextul
                    produselor/Serviciilor prestate prin intermediul Site-ului, inclusiv a obligațiilor în materie
                    fiscală, precum și în materie de arhivare.
                </li>
            </ul>
            <p>Prelucrarea Datelor dumneavoastră pentru acest scop este necesară în baza unor obligații legale.
                Furnizarea Datelor dumneavoastră în acest scop este necesară. Refuzul furnizării Datelor poate avea
                drept consecință imposibilitatea S.C. ENFASI LIVING CONCEPT S.R.L. de a respecta obligațiile legale care
                îi revin și deci în imposibilitatea de a vă oferi Serviciile prin intermediul Site-ului.</p>
            <ul className="nested-list">
                <li>pentru activităţi de marketing, respectiv pentru transmiterea, prin intermediul mijloacelor de
                    comunicare la distanţă (e-mail, sms) de comunicări comerciale privind Serviciile oferite de ENFASI
                    LIVING CONCEPT S.R.L., prin intermediul Site-ului.
                </li>
            </ul>
            <p>Prelucrarea Datelor dumneavoastră pentru acest scop are la bază consimțământul dumneavoastră, dacă
                alegeți să-l furnizați.</p>
            <p>Vă puteți exprima consimțământul pentru Prelucrarea Datelor în acest scop prin bifarea căsuței
                corespunzătoare de la momentul achiziționării Pachetului de Servicii. Pentru dezabonarea de la
                primirea unor astfel de comunicări comerciale puteți trimite un e-mail la adresa <a
                    href="mailto:contact@diaphan.ro">contact@diaphan.ro</a> în care să precizați decizia de dezabonare.
            </p>
            <p>Furnizarea Datelor dumneavoastră în acest scop este voluntară. Refuzul furnizării consimțământului pentru
                Prelucrarea Datelor dumneavoastră în acest scop nu va avea urmări negative pentru dumneavoastră.</p>
            <ul className="nested-list">
                <li>în scopul efectuării diverselor analize, raportări privind modul de funcționare a Site, realizarea
                    de profiluri de preferințe de consum, în principal, în vederea îmbunătățiri experienței oferite pe
                    Site.
                </li>
            </ul>
            <p>Prelucrarea Datelor dumneavoastră pentru acest scop are la bază interesul legitim al ENFASI LIVING
                CONCEPT S.R.L. de a îmbunătății permanent experiența clienților pe Site. Furnizarea Datelor
                dumneavoastră în acest scop este voluntară. Refuzul furnizării Datelor pentru acest scop nu va avea
                urmări negative pentru dumneavoastră.</p>
            <p><strong>4.2</strong> Dacă sunteți vizitator al Site-ului, ENFASI LIVING CONCEPT S.R.L. Prelucrează Datele
                dumneavoastră cu Caracter Personal astfel:</p>
            <ul className="nested-list">
                <li>pentru activităţi de marketing, respectiv pentru transmiterea, prin intermediul mijloacelor de
                    comunicare la distanţă (e-mail, sms), de comunicări comerciale privind Serviciile oferite de ENFASI
                    LIVING CONCEPT S.R.L., prin intermediul Site-ului.
                </li>
            </ul>
            <p>Prelucrarea Datelor dumneavoastră pentru acest scop are la bază consimțământul dumneavoastră, dacă
                alegeți să-l furnizați.</p>
            <p>Vă puteți exprima consimțământul pentru Prelucrarea Datelor în acest scop prin bifarea căsuței
                corespunzătoare de la momentul achiziționării Pachetului de Servicii. Pentru dezabonarea de la
                primirea unor astfel de comunicări comerciale puteți trimite un e-mail la adresa <a
                    href="mailto:contact@diaphan.ro">contact@diaphan.ro</a> în care să precizați decizia de dezabonare.
            </p>
            <p>
                Furnizarea Datelor dumneavoastră în acest scop este voluntară. Refuzul furnizării consimțământului
                pentru Prelucrarea Datelor dumneavoastră în acest scop nu va avea urmări negative pentru dumneavoastră.
            </p>
            <ul className="nested-list">
                <li>pentru rezolvarea plângerilor, reclamaţiilor şi pentru a monitoriza traficul și a îmbunătăţii
                    experiența dumneavoastră oferită pe Site.
                </li>
            </ul>
            <p>Prelucrarea Datelor dumneavoastră pentru acest scop are la bază interesul legitim al ENFASI LIVING
                CONCEPT S.R.L. de a asigura funcționarea corectă a Site-ului, precum și pentru a îmbunătății permanent
                experiența vizitatorilor Site-ului, inclusiv prin soluționarea diferitelor comentarii, întrebări sau
                reclamații.</p>
            <p>Furnizarea Datelor dumneavoastră în acest scop este voluntară. Refuzul furnizării Datelor pentru acest
                scop nu va avea urmări negative pentru dumneavoastră.</p>
            <p className="app-space-dummy"></p>
            <p className="font-bold text-xl mb-2"><strong>5. Durata pentru care vă Prelucrăm Datele cu Caracter Personal</strong></p>
            <p>ENFASI LIVING CONCEPT S.R.L. va Prelucra Datele dumneavoastră cu Caracter Personal atât cât este necesar
                pentru realizarea scopurilor de Prelucrare menționate mai sus.</p>
            <p>În cazul în care sunteți Client și/sau Cumpărător, vom Prelucra Datele dumneavoastră pe întreaga durată a
                raporturilor contractuale și ulterior conform obligațiilor legale care revin în sarcina ENFASI LIVING
                CONCEPT S.R.L. (de ex., în cazul documentelor justificative financiar-contabile pentru care termenul de
                păstrare prevăzut de lege este de 10 ani de la data încheierii exerciţiului financiar în cursul căruia
                au fost întocmite).</p>
            <p>În situaţia în care sunteți Client și/sau Cumpărător și vă exercitați opțiunea de închidere a contului
                ori încetării contractului încheiat înainte de expirarea duratei abonamentului, vă rugăm să să
                transmiteți o solicitare expresă în acest sens la adresa de e-mail
                <a href="mailto:contact@diaphan.ro"> contact@diaphan.ro</a>. Totuși, dorim să vă
                informăm că această acțiune nu va avea ca efect automat ștergerea Datelor dumneavoastră cu Caracter
                Personal. În cazul în care doriți să nu vă mai fie Prelucrate Datele cu Caracter Personal sau dacă
                doriți ștergerea Datelor, vă puteți exercita drepturile detaliate la punctul VII de mai jos.</p>
            <p>De asemenea, dacă solicitați să vă dezabonați de la Serviciile de Newsletter, puteți transmite o
                solicitarea expresă în acest sens la adresa de email
                <a href="mailto:contact@diaphan.ro"> contact@diaphan.ro</a>, iar ENFASI LIVING CONCEPT S.R.L.
                va interpreta această acțiune ca opțiunea dumneavoastră de a vă dezabona de la primirea de comunicări
                comerciale prin care vă ținem la curent despre produsele și Serviciile oferite prin intermediul
                Site-ului. În acest sens, dacă alegeți să vă închideți contul de Client și/sau Cumpărător, nu vă vom mai
                trimite e-mailuri și/sau sms-uri de acest gen. Totuși, dorim să vă informăm că închiderea contului nu va
                avea ca efect automat ștergerea Datelor dumneavoastră cu Caracter Personal. În cazul în care doriți să
                nu vă mai fie Prelucrate Datele cu Caracter Personal sau dacă doriți ștergerea Datelor, vă puteți
                exercita drepturile detaliate la punctul VII de mai jos.</p>
            <p>Dacă vă retrageți consimțământul pentru Prelucrarea Datelor în scop de marketing, ENFASI LIVING CONCEPT
                S.R.L. va înceta Prelucrarea Datelor dumneavoastră cu Caracter Personal în acest scop, fără însă a
                afecta Prelucrările desfășurate de ENFASI LIVING CONCEPT S.R.L. pe baza consimțământului exprimat de
                către dumneavoastră înainte de retragerea acestuia.</p>
            <p className="app-space-dummy"></p>
            <p className="font-bold text-xl mb-2"><strong>6. Dezvăluirea Datelor cu Caracter Personal</strong></p>
            <p>Pentru îndeplinirea scopurilor de Prelucrare, ENFASI LIVING CONCEPT S.R.L. poate dezvălui Datele
                dumneavoastră către parteneri, către terțe persoane sau entități care sprijină ENFASI LIVING CONCEPT
                S.R.L. în desfășurarea activității prin intermediul Site-ului (de operatori de plăți, furnizori de
                servicii IT), ori către autoritățile publice centrale/locale, în următoarele cazuri exemplificativ
                enumerate:</p>
            <ul className="nested-list">
                <li>pentru administrarea Site-ului;</li>
                <li>pentru menținerea, Personalizarea și îmbunătățirea Site-ului și a Serviciilor derulate/produselor
                    vândute prin intermediul lui;
                </li>
                <li>pentru efectuarea analizei Datelor, testarea și cercetarea, monitorizarea tendințelor de utilizare
                    și activitate, dezvoltarea Caracteristicilor de siguranță și autentificarea utilizatorilor;
                </li>
                <li>pentru transmiterea de comunicări comerciale de marketing, în condițiile și limitele prevăzute de
                    lege;
                </li>
                <li>pentru aducerea la îndeplinire a comenzii de achiziționare a unui Pachet;</li>
                <li>atunci când dezvăluirea Datelor cu Caracter Personal este prevăzută de lege; etc.</li>
            </ul>
            <p className="app-space-dummy"></p>
            <p className="font-bold text-xl mb-2"><strong>7. Transferul Datelor cu Caracter Personal</strong></p>
            <p>Datele cu Caracter Personal furnizate către ENFASI LIVING CONCEPT S.R.L. pot fi transferate în afara
                României, dar doar către state din Uniunea Europeană.</p>
            <p className="app-space-dummy"></p>
            <p className="font-bold text-xl mb-2"><strong>8. Drepturile de care beneficiați</strong></p>
            <p>În condițiile prevăzute de legislația în materia Prelucrării Datelor cu Caracter Personal, în calitate de
                persoane vizate, beneficiați de următoarele drepturi:</p>
            <ul className="nested-list">
                <li>dreptul la informare, respectiv dreptul de a primi detalii privind activitățile de Prelucrare
                    efectuate de către ENFASI LIVING CONCEPT S.R.L., conform celor descrise în prezentul document;
                </li>
                <li>dreptul de acces la Date, respectiv dreptul de a obține confirmarea din partea ENFASI LIVING CONCEPT
                    S.R.L. cu privire la Prelucrarea Datelor cu Caracter Personal, precum și detalii privind
                    activitățile de Prelucrare, modalitatea în care sunt Prelucrate Datele, scopul în care se face
                    Prelucrarea, destinatarii sau categoriile de destinatari ai Datelor, etc;
                </li>
                <li>dreptul la rectificare, respectiv dreptul de a obține corectarea, fără întârzieri justificate, de
                    către ENFASI LIVING CONCEPT S.R.L. a Datelor cu Caracter Personal inexacte/nejustificate, precum și
                    completarea Datelor incomplete; Rectificarea/completarea va fi comunicată fiecărui destinatar la
                    care au fost transmise Datele, cu excepția cazului în care acest lucru se dovedește imposibil sau
                    presupune eforturi disproporționate.
                </li>
                <li>dreptul la ștergerea Datelor, fără întârzieri nejustificate, („dreptul de a fi uitat”), în cazul in
                    care se aplică unul dintre următoarele motive:
                    <ul className="nested-list">
                        <li>acestea nu mai sunt necesare pentru îndeplinirea scopurilor pentru care au fost colectate
                            sau Prelucrate;
                        </li>
                        <li>în cazul în care este retras consimțământul și nu există niciun alt temei juridic pentru
                            Prelucrare;
                        </li>
                        <li>în cazul în care Persoana Vizată se opune Prelucrării și nu există motive legitime care să
                            prevaleze;
                        </li>
                        <li>în cazul în care Datele cu Caracter Personal au fost Prelucrate ilegal;</li>
                        <li>în cazul în care Datele cu Caracter Personal trebuie șterse pentru respectarea unei
                            obligații legale;
                        </li>
                        <li>Datele cu Caracter Personal au fost colectate în legătură cu oferirea de servicii ale
                            societății informaționale conform dreptului Uniunii sau al dreptului intern sub incidenta
                            căruia se află operatorul.
                        </li>
                    </ul>
                </li>
                <li>Este posibil ca, în urma solicitării de ștergere a Datelor, ENFASI LIVING CONCEPT S.R.L. să
                    anonimizeze aceste Date (lipsindu-le astfel de Caracterul Personal) și să continue în aceste
                    condiții Prelucrarea pentru scopuri statistice;
                </li>
                <li>dreptul la restricționarea Prelucrării în măsura în care:
                    <ul className="nested-list">
                        <li>persoana contestă exactitatea Datelor, pe o perioadă care ne permite verificarea
                            corectitudinii Datelor;
                        </li>
                        <li>Prelucrarea este ilegală, iar Persoana Vizată se opune ștergerii Datelor cu Caracter
                            Personal, solicitând în schimb restricționarea utilizării lor;
                        </li>
                        <li>operatorul nu mai are nevoie de Datele cu Caracter Personal în scopul Prelucrării, dar
                            Persoana Vizată i le solicită pentru constatarea, exercitarea sau apărarea unui drept în
                            instanță; sau
                        </li>
                        <li>Persoana Vizată s-a opus Prelucrării (altele decât cele de marketing direct), pentru
                            intervalul de timp în care se verifică dacă drepturile legitime ale operatorului
                            prevalează asupra celor ale persoanei vizate.
                        </li>
                    </ul>
                </li>
                <li>dreptul la portabilitatea Datelor, respectiv:
                    <ul className="nested-list">
                        <li>dreptul de a primi Datele cu Caracter Personal într-o modalitate structurată, folosită
                            în mod obișnuit și într-un format ușor de citit, precum și
                        </li>
                        <li>dreptul ca aceste Date să fie transmise de către ENFASI LIVING CONCEPT S.R.L. către alt
                            operator de Date, în măsura în care sunt îndeplinite condițiile prevăzute de lege;
                        </li>
                    </ul>
                </li>
                <li>dreptul la opoziție – în ceea ce privește activitățile de Prelucrare se poate exercita prin
                    transmiterea unei solicitări conform celor indicate mai jos;
                    <ul className="nested-list">
                        <li>în orice moment, din motive legate de situația particulară în care se află Persoana
                            Vizată, ca Datele care o vizează să fie Prelucrate în temeiul interesului legitim al
                            ENFASI LIVING CONCEPT S.R.L. sau în temeiul interesului public, cu excepția cazurilor în
                            care ENFASI LIVING CONCEPT S.R.L. poate demonstra că are motive legitime și imperioase
                            care justifică Prelucrarea și care prevalează asupra intereselor, drepturilor și
                            libertăților persoanelor vizate sau că scopul este constatarea, exercitarea sau apărarea
                            unui drept în instanță;
                        </li>
                        <li>în orice moment, în mod gratuit și fără nicio justificare, că Datele care o vizează să
                            fie Prelucrate în scop de marketing direct.
                        </li>
                    </ul>
                </li>
                <li>dreptul de a nu fi supus unei decizii individuale automate, respectiv dreptul de a nu fi subiectul
                    unei decizii luate numai pe baza unor activități de Prelucrare automate, inclusiv crearea de
                    profiluri, care produce efecte juridice care privesc Persoana Vizată sau o afectează în mod similar
                    într-o măsură semnificativă;
                </li>
                <li>dreptul de a vă adresa Autorităţii Naţionale de Supraveghere a Prelucrării Datelor cu Caracter
                    Personal sau instanțelor competente, în măsura în care considerați necesar.
                </li>
            </ul>
            <p>Pentru asigurarea celui mai sporit grad de securitate a Datelor Personale ale Utilizatorilor, Cliențior
                și ale Cumpărătorilor, a fost numit un Ofițer pentru Protecția Datelor care poate fi contactat la adresa
                <a href="mailto:contact@diaphan.ro"> contact@diaphan.ro</a> în situația în care există nelămuriri
                referitoare la protecția Datelor Personale.</p>
            <p>De asemenea, pentru orice alte întrebări suplimentare cu privire la modul în care Datele cu Caracter
                Personal sunt Prelucrate și pentru a vă exercita drepturile menționate mai sus, vă rugăm să vă adresați
                la adresa de email: <a href="mailto:contact@diaphan.ro"> contact@diaphan.ro</a>.
            </p>
            <p>Această pagină de Internet folosește fișiere de tip cookie. Pentru mai multe informații cu privire la
                modul în care se folosesc aceste fișiere, vă rugăm să accesați următorul
                <Link onClick={scrollToTop} href={'/info/politica-cookies'}> link</Link>.</p>
            <p className="app-space-dummy"></p>
            <p>Ultima actualizare: 05.05.2024</p>
        </div>
    );
}

export default AppConfidentialityPolicy;
